import React, { useEffect, useState } from "react";
import {
  MdOutlineArrowForwardIos,
  MdOutlineArrowBackIos,
} from "react-icons/md";
import BaseCheckbox from "../../../../General/FormsComp/CheckBox";

export default function TransferTable({
  servicos,
  servicosPrestados,
  leftTableData,
  setLeftTableData,
  rightTableData,
  setRightTableData,
}) {
  const [selectedItemsLeft, setSelectedItemsLeft] = useState([]);
  const [selectedItemsRight, setSelectedItemsRight] = useState([]);
  const [selectAllLeft, setSelectAllLeft] = useState(false);
  const [selectAllRight, setSelectAllRight] = useState(false);

  const toggleSelect = (item, table) => {
    const setSelectedItems =
      table === "left" ? setSelectedItemsLeft : setSelectedItemsRight;
    const selectedItems =
      table === "left" ? selectedItemsLeft : selectedItemsRight;

    setSelectedItems((prevSelected) =>
      selectedItems.includes(item)
        ? prevSelected.filter((i) => i !== item)
        : [...prevSelected, item]
    );
  };

  const moveItems = (fromTable, toTable, selectedItems) => {
    const removeFromTable = fromTable.filter(
      (item) => !selectedItems.includes(item)
    );
    const addToTable = toTable.concat(
      selectedItems.filter((item) => !toTable.includes(item))
    );

    fromTable === leftTableData
      ? setLeftTableData(removeFromTable)
      : setRightTableData(removeFromTable);
    toTable === leftTableData
      ? setLeftTableData(addToTable)
      : setRightTableData(addToTable);
  };

  const moveRight = () => {
    moveItems(leftTableData, rightTableData, selectedItemsLeft);
    setSelectedItemsLeft([]);
    setSelectAllLeft(false);
  };

  const moveLeft = () => {
    moveItems(rightTableData, leftTableData, selectedItemsRight);
    setSelectedItemsRight([]);
    setSelectAllRight(false);
  };

  const handleCheckboxChange = (table) => {
    const setSelectAll =
      table === "left" ? setSelectAllLeft : setSelectAllRight;
    const setSelectedItems =
      table === "left" ? setSelectedItemsLeft : setSelectedItemsRight;
    const tableData = table === "left" ? leftTableData : rightTableData;
    const selectAll = table === "left" ? selectAllLeft : selectAllRight;

    setSelectAll(!selectAll);
    setSelectedItems(selectAll ? [] : tableData || []);
  };

  useEffect(() => {
    if (servicos && servicosPrestados) {
      const servicosRelacionados = servicos.filter((servico) =>
        servicosPrestados.some(
          (prestado) => prestado.nome_servico === servico.nome
        )
      );
      const servicosNaoRelacionados = servicos.filter(
        (servico) =>
          !servicosPrestados.some(
            (prestado) => prestado.nome_servico === servico.nome
          )
      );

      setLeftTableData(servicosNaoRelacionados);
      setRightTableData(servicosRelacionados);
    }
  }, [servicos, servicosPrestados]);

  const renderTable = (
    tableData,
    selectedItems,
    handleCheckboxChange,
    selectAll
  ) => (
    <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm">
      <div className="px-4 py-3 border-b border-gray-200 dark:border-gray-700">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
            {tableData === leftTableData
              ? "Selecione o serviço"
              : "Serviço prestado"}
          </h3>
          <BaseCheckbox
            id={`select-all-${tableData === leftTableData ? 'left' : 'right'}`}
            checked={selectAll}
            onChange={() =>
              handleCheckboxChange(
                tableData === leftTableData ? "left" : "right"
              )
            }
            size="sm"
            variant="primary"
            className="mr-2"
          />
        </div>
      </div>
      
      <div className="max-h-64 overflow-y-auto">
        {tableData?.length === 0 ? (
          <div className="px-4 py-8 text-center">
            <div className="text-gray-400 dark:text-gray-500 text-sm">
              Nenhuma informação disponível!
            </div>
          </div>
        ) : (
          <div className="divide-y divide-gray-200 dark:divide-gray-700">
            {tableData?.map((servico) => (
              <div
                key={servico.id}
                className="px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors duration-150"
              >
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-3 flex-1">
                    <BaseCheckbox
                      id={`servico-${servico.id}`}
                      checked={selectedItems.includes(servico)}
                      onChange={() =>
                        toggleSelect(
                          servico,
                          tableData === leftTableData ? "left" : "right"
                        )
                      }
                      size="sm"
                      variant="primary"
                    />
                    <div className="flex-1">
                      <div className="text-sm font-medium text-gray-900 dark:text-white">
                        {servico.nome}
                      </div>
                      {servico.descricao && (
                        <div className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                          {servico.descricao}
                        </div>
                      )}
                    </div>
                  </div>
                  {servico.categoria && (
                    <div className="ml-4">
                      <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-vox-blue-100 text-vox-blue-800 dark:bg-vox-blue-900 dark:text-vox-blue-200">
                        {servico.categoria}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 items-start">
        {/* Tabela Esquerda */}
        <div className="lg:col-span-1">
          {renderTable(
            leftTableData,
            selectedItemsLeft,
            handleCheckboxChange,
            selectAllLeft
          )}
        </div>

        {/* Botões de Ação */}
        <div className="flex flex-col items-center justify-center space-y-4 lg:col-span-1">
          <div className="flex flex-col space-y-3">
            <button
              onClick={moveRight}
              disabled={selectedItemsLeft.length === 0}
              className="flex items-center justify-center w-12 h-12 bg-vox-blue-600 hover:bg-vox-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed text-white rounded-full transition-all duration-200 shadow-lg hover:shadow-xl transform hover:scale-105"
              title="Mover para direita"
            >
              <MdOutlineArrowForwardIos size={20} />
            </button>
            <button
              onClick={moveLeft}
              disabled={selectedItemsRight.length === 0}
              className="flex items-center justify-center w-12 h-12 bg-vox-blue-600 hover:bg-vox-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed text-white rounded-full transition-all duration-200 shadow-lg hover:shadow-xl transform hover:scale-105"
              title="Mover para esquerda"
            >
              <MdOutlineArrowBackIos size={20} />
            </button>
          </div>
          
          {/* Contadores */}
          <div className="text-center space-y-2">
            <div className="text-sm text-gray-600 dark:text-gray-400">
              Selecionados: {selectedItemsLeft.length}
            </div>
            <div className="text-sm text-gray-600 dark:text-gray-400">
              Total: {leftTableData?.length || 0}
            </div>
          </div>
        </div>

        {/* Tabela Direita */}
        <div className="lg:col-span-1">
          {renderTable(
            rightTableData,
            selectedItemsRight,
            handleCheckboxChange,
            selectAllRight
          )}
        </div>
      </div>

      {/* Resumo */}
      <div className="bg-gray-50 dark:bg-gray-800 rounded-lg p-4 border border-gray-200 dark:border-gray-700">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
          <div>
            <div className="text-2xl font-bold text-vox-blue-600">
              {leftTableData?.length || 0}
            </div>
            <div className="text-sm text-gray-600 dark:text-gray-400">
              Serviços Disponíveis
            </div>
          </div>
          <div>
            <div className="text-2xl font-bold text-green-600">
              {rightTableData?.length || 0}
            </div>
            <div className="text-sm text-gray-600 dark:text-gray-400">
              Serviços Prestados
            </div>
          </div>
          <div>
            <div className="text-2xl font-bold text-orange-600">
              {selectedItemsLeft.length}
            </div>
            <div className="text-sm text-gray-600 dark:text-gray-400">
              Selecionados (Esquerda)
            </div>
          </div>
          <div>
            <div className="text-2xl font-bold text-purple-600">
              {selectedItemsRight.length}
            </div>
            <div className="text-sm text-gray-600 dark:text-gray-400">
              Selecionados (Direita)
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
